<div id="residence-content" class="divWhiteBackground">
  <form
    id="cac-residential-details-form"
    class="formStyle"
    [formGroup]="residenceForm"
  >
    <div class="form-group">
      <h2 class="h2-black center">
        {{ formFieldData?.titlePrefix + ' ' + formFieldData?.titlePostfix }}
      </h2>
      <div class="body-black center" id="cac-residence-estd-span">
        <p>{{ formFieldData?.subTitle }}</p>
      </div>
    </div>

    <div class="form-group pt-60">
      <div
        role="alert"
        *ngIf="profanityFlag"
        aria-atomic="true"
        id="profanityErrorDiv"
        class="validation-error"
      >
        <!-- replace with the static doc content -->
        Profanity found in the text entered.
      </div>
    </div>

    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-residence-div-error-addressLine1"
          [ngClass]="
            f.addressLine1.touched && f.addressLine1.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
          class="form-group"
        >
          <p
            id="cac-residence-label-addressLine1"
            class="control-label form-field-black"
            [class.validation-error]="
              f.addressLine1.touched && f.addressLine1.errors
            "
          >
            {{ formFieldData?.formsFields?.addressLine1?.label }}
          </p>

          <input
            id="cac-residence-addressLine1"
            aria-labelledby="cac-residence-label-addressLine1"
            type="text"
            autoComplete="off"
            class="form-control col-left form-field-black"
            placeholder=""
            name="addressLine1"
            formControlName="addressLine1"
            wwwLibPlacesAutocomplete
            [wwwLibPlacesAutocompleteOptions]="autocompleteOptions"
            (placeChanged)="handleAddressChange($event)"
            maxLength="41"
            streetAddress
            addressType="street"
            (blur)="removeSpaces($event)"
          />
          <span
            *ngIf="f.addressLine1.touched && f.addressLine1.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="f.addressLine1.touched && f.addressLine1.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="ErraddressLine1 errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.addressLine1?.errors?.adde1 }}
        </div>
        <div
          *ngIf="
            f.addressLine1.touched &&
            !f.addressLine1.errors?.isNotEmpty &&
            f.addressLine1.errors?.streetNumberError
          "
          role="alert"
          aria-atomic="true"
          class="ErraddressLine1 errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.addressLine1?.errors?.adde3 }}
        </div>
        <div
          *ngIf="
            f.addressLine1.touched &&
            !f.addressLine1.errors?.isNotEmpty &&
            !f.addressLine1.errors?.streetNumberError &&
            f.addressLine1.errors?.streetNameError
          "
          role="alert"
          aria-atomic="true"
          class="ErraddressLine1 errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.addressLine1?.errors?.adde2 }}
        </div>
        <div
          *ngIf="
            f.addressLine1.touched && f.addressLine1.errors?.isNotProfanity
          "
          role="alert"
          aria-atomic="true"
          data-testid="addressLine1-profanity"
          class="errWidthM required mobileOnly validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
      </div>
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-residence-div-addressLine2"
          class="form-group"
          [ngClass]="
            f.addressLine2.touched && f.addressLine2.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
        >
          <p
            id="cac-residence-label-addressLine2"
            htmlFor="addressLine2"
            class="control-label form-field-black"
          >
            {{ formFieldData?.formsFields?.addressLine2?.label }}
          </p>
          <input
            id="cac-residence-addressLine2"
            aria-labelledby="cac-residence-div-addressLine2"
            type="text"
            class="form-control col-right form-field-black"
            placeholder=""
            name="addressLine2"
            formControlName="addressLine2"
            maxLength="10"
            streetAddress
            addressType="unit"
            (blur)="removeSpaces($event)"
          />
          <span
            *ngIf="f.addressLine2.touched && f.addressLine2.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
          <div
            *ngIf="
              f.addressLine2.touched && f.addressLine2.errors?.isNotProfanity
            "
            role="alert"
            aria-atomic="true"
            data-testid="addressLine2-profanity"
            class="errWidthM required mobileOnly validation-error"
          >
            {{ globalText?.errors?.proferr1 }}
          </div>
          <div
            *ngIf="f.addressLine2.touched && f.addressLine2.errors?.maxlength"
            role="alert"
            aria-atomic="true"
            class="errWidthM required mobileOnly validation-error"
          >
            {{ formFieldData?.formsFields?.addressLine2?.errors?.adde1 }}
          </div>
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8">
        <div
          role="alert"
          *ngIf="f.addressLine1.touched && f.addressLine1.errors?.isNotEmpty"
          aria-atomic="true"
          class="ErraddressLine1 errWidthL required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.addressLine1?.errors?.adde1 }}
        </div>
        <div
          role="alert"
          *ngIf="
            f.addressLine1.touched &&
            !f.addressLine1.errors?.isNotEmpty &&
            f.addressLine1.errors?.streetNumberError
          "
          aria-atomic="true"
          class="ErraddressLine1 errWidthL required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.addressLine1?.errors?.adde3 }}
        </div>
        <div
          role="alert"
          *ngIf="
            f.addressLine1.touched &&
            !f.addressLine1.errors?.isNotEmpty &&
            !f.addressLine1.errors?.streetNumberError &&
            f.addressLine1.errors?.streetNameError
          "
          aria-atomic="true"
          class="ErraddressLine1 errWidthL required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.addressLine1?.errors?.adde2 }}
        </div>
        <div
          *ngIf="
            f.addressLine1.touched && f.addressLine1.errors?.isNotProfanity
          "
          role="alert"
          aria-atomic="true"
          data-testid="addressLine1-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
      </div>
      <div class="custom-display-inline col-md-8 float-right">
        <div
          *ngIf="
            f.addressLine2.touched && f.addressLine2.errors?.isNotProfanity
          "
          role="alert"
          aria-atomic="true"
          data-testid="addressLine2-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
        <div
          *ngIf="f.addressLine2.touched && f.addressLine2.errors?.maxlength"
          role="alert"
          aria-atomic="true"
          class="errWidthM required validation-error"
        >
          {{ formFieldData?.formsFields?.addressLine2?.errors?.adde1 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop-97-5">
      <div class="custom-column-full custom-display-inline col-md-8 divwidth">
        <div
          id="cac-residence-div-error-city"
          [ngClass]="
            f.city.touched && f.city.errors ? 'has-error' : 'mobileView-pb-15'
          "
          class="form-group"
        >
          <p
            id="cac-residence-label-city"
            htmlFor="city"
            class="control-label form-field-black"
            [class.validation-error]="f.city.touched && f.city.errors"
          >
            {{ formFieldData?.formsFields?.city?.label }}
          </p>

          <input
            id="cac-residence-city"
            aria-labelledby="cac-residence-div-error-city"
            type="text"
            onlyAlphabets
            class="form-control form-field-black"
            placeholder=""
            name="city"
            formControlName="city"
            maxLength="64"
            pattern="[a-zA-Z\s]+"
            (blur)="removeSpaces($event)"
          />
          <span
            *ngIf="f.city.touched && f.city.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="f.city.touched && f.city.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="Errcity errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.city?.errors?.citye1 }}
        </div>
        <div
          *ngIf="
            f.city.touched &&
            !f.city.errors?.isNotEmpty &&
            f.city.errors?.isAlpha
          "
          role="alert"
          aria-atomic="true"
          class="Errcity errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.city?.errors?.citye2 }}
        </div>
        <div
          *ngIf="f.city.touched && f.city.errors?.isNotProfanity"
          role="alert"
          aria-atomic="true"
          data-testid="city-profanity"
          class="errWidthM required validation-error"
        >
          {{ globalText?.errors?.proferr1 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop divwidth">
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="f.city.touched && f.city.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.city?.errors?.citye1 }}
        </div>
        <div
          *ngIf="
            f.city.touched &&
            !f.city.errors?.isNotEmpty &&
            f.city.errors?.isAlpha
          "
          role="alert"
          aria-atomic="true"
          class="errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.city?.errors?.citye2 }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-residence-div-error-userState"
          [ngClass]="
            f.userState.touched && f.userState.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
          class="form-group dropdown-caret"
        >
          <p
            id="cac-residence-label-userState"
            htmlFor="userState"
            class="control-label form-field-black"
            [class.validation-error]="f.userState.touched && f.userState.errors"
          >
            {{ formFieldData?.formsFields?.state?.label }}
          </p>

          <select
            id="cac-residence-userState"
            aria-labelledby="cac-residence-label-userState"
            name="userState"
            formControlName="userState"
            class="form-control col-right form-field-black"
          >
            <option *ngFor="let item of usStates" [value]="item.value">
              {{ item.label }}
            </option>
          </select>
          <span
            *ngIf="f.userState.touched && f.userState.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="f.userState.touched && f.userState.errors"
          role="alert"
          aria-atomic="true"
          class="ErruserState errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.state?.errors?.statee1 }}
        </div>
      </div>
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-residence-div-error-zipCode"
          class="form-group"
          [ngClass]="
            f.zipCode.touched && f.zipCode.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
        >
          <p
            id="cac-residence-label-zipCode"
            htmlFor="zipCode"
            class="form-field-black control-label"
            [class.validation-error]="f.zipCode.touched && f.zipCode.errors"
          >
            {{ formFieldData?.formsFields?.zipCode?.label }}
          </p>

          <input
            id="cac-residence-zipCode"
            aria-labelledby="cac-residence-label-zipCode"
            formControlName="zipCode"
            type="text"
            inputmode="numeric"
            mask="00000"
            class="form-control col-left form-field-black"
            name="zipCode"
            maxLength="5"
            pattern="[0-9]+"
          />
          <span
            *ngIf="f.zipCode.touched && f.zipCode.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="f.zipCode.touched && f.zipCode.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="ErrzipCode errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.zipCode?.errors?.zip1 }}
        </div>
        <div
          *ngIf="
            f.zipCode.touched &&
            f.zipCode.errors &&
            !f.zipCode.errors.territoryError &&
            !f.zipCode.errors.isNotEmpty
          "
          role="alert"
          aria-atomic="true"
          class="ErrzipCode mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.zipCode?.errors?.zip2 }}
        </div>
        <div
          *ngIf="f.zipCode.touched && f.zipCode.errors?.territoryError"
          role="alert"
          aria-atomic="true"
          class="ErrzipCode mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.zipCode?.errors?.zip3 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="f.userState.touched && f.userState.errors"
          role="alert"
          aria-atomic="true"
          class="ErruserState errWidthL required validation-error"
        >
          {{ formFieldData?.formsFields?.state?.errors?.statee1 }}
        </div>
      </div>
      <div class="custom-display-inline col-md-8">
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="f.zipCode.touched && f.zipCode.errors?.isNotEmpty"
          class="ErrzipCode errWidthL required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.zipCode?.errors?.zip1 }}
        </div>
        <div
          *ngIf="
            f.zipCode.touched &&
            f.zipCode.errors &&
            !f.zipCode.errors.territoryError &&
            !f.zipCode.errors.isNotEmpty
          "
          role="alert"
          aria-atomic="true"
          class="ErrzipCode required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.zipCode?.errors?.zip2 }}
        </div>
        <div
          *ngIf="f.zipCode.touched && f.zipCode.errors?.territoryError"
          role="alert"
          aria-atomic="true"
          class="ErrzipCode required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.zipCode?.errors?.zip3 }}
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-residence-div-error-monthResiding"
          [ngClass]="
            f.monthResiding.touched && f.monthResiding.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
          class="form-group"
        >
          <p
            id="cac-residence-label-monthResiding"
            htmlFor="monthResiding"
            class="form-field-black control-label"
            [class.validation-error]="
              f.monthResiding.touched && f.monthResiding.errors
            "
          >
            {{ formFieldData?.formsFields?.monthResiding?.label }}
          </p>

          <input
            id="cac-residence-monthResiding"
            aria-labelledby="cac-residence-label-monthResiding"
            type="text"
            inputmode="numeric"
            class="form-control col-left form-field-black"
            placeholder="MM/YYYY"
            mask="00/0000"
            [dropSpecialCharacters]="false"
            name="monthResiding"
            formControlName="monthResiding"
            maxLength="7"
          />
          <span
            *ngIf="f.monthResiding.touched && f.monthResiding.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="
            f.monthResiding.touched &&
            f.monthResiding.errors &&
            f.monthResiding.errors.isNotEmpty
          "
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding mobileOnly required validation-error mobileView-pb-15"
        >
          Please tell us when did you start living at residence.
        </div>

        <div
          *ngIf="
            f.monthResiding.touched &&
            f.monthResiding.errors &&
            !f.monthResiding.errors.isNotEmpty &&
            !f.monthResiding.errors.dobMisMatchError
          "
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.monthResiding?.errors?.monrese1 }}
        </div>
        <div
          *ngIf="
            f.monthResiding.touched && f.monthResiding.errors?.dobMisMatchError
          "
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.monthResiding?.errors?.monrese2 }}
        </div>
      </div>
      <div class="custom-column-full custom-display-inline col-md-8">
        <div
          id="cac-residence-div-error-ownedBy"
          [ngClass]="
            f.ownedBy.touched && f.ownedBy.errors
              ? 'has-error'
              : 'mobileView-pb-15'
          "
          class="form-group dropdown-caret"
        >
          <p
            id="cac-residence-label-ownedBy"
            htmlFor="ownedByField"
            class="form-field-black control-label"
            [class.validation-error]="f.ownedBy.touched && f.ownedBy.errors"
          >
            {{ formFieldData?.formsFields?.ownedBy?.label }}
          </p>

          <select
            id="cac-residence-ownedBy"
            aria-labelledby="cac-residence-label-ownedBy"
            name="ownedByField"
            formControlName="ownedBy"
            class="form-control col-right form-field-black"
          >
            <option *ngFor="let item of ownedByList" [value]="item.value">
              {{ item.label }}
            </option>
          </select>
          <span
            *ngIf="f.ownedBy.touched && f.ownedBy.errors"
            class="validation-error-icon"
            ><img class="error-icn" src="{{ exclamation }}" alt="err"
          /></span>
        </div>
        <div
          *ngIf="f.ownedBy.touched && f.ownedBy.errors?.isNotEmpty"
          role="alert"
          aria-atomic="true"
          class="ErrownedBy errWidthL mobileOnly required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.ownedBy?.errors?.ownedbye1 }}
        </div>
      </div>
    </div>
    <div class="form-group desktop">
      <div class="custom-display-inline col-md-8">
        <div
          *ngIf="
            f.monthResiding.touched &&
            f.monthResiding.errors &&
            f.monthResiding.errors.isNotEmpty
          "
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding required validation-error"
        >
          Please tell us when did you start living at residence.
        </div>
        <div
          *ngIf="
            f.monthResiding.touched &&
            f.monthResiding.errors &&
            !f.monthResiding.errors.isNotEmpty &&
            !f.monthResiding.errors.dobMisMatchError
          "
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding required validation-error"
        >
          {{ formFieldData?.formsFields?.monthResiding?.errors?.monrese1 }}
        </div>
        <div
          *ngIf="
            f.monthResiding.touched && f.monthResiding.errors?.dobMisMatchError
          "
          role="alert"
          aria-atomic="true"
          class="ErrmonthResiding required validation-error"
        >
          {{ formFieldData?.formsFields?.monthResiding?.errors?.monrese2 }}
        </div>
      </div>
      <div class="custom-display-inline col-md-8">
        <div
          role="alert"
          aria-atomic="true"
          *ngIf="
            f.ownedBy.touched && f.ownedBy.errors && f.ownedBy.errors.isNotEmpty
          "
          class="ErrownedBy errWidthL required validation-error mobileView-pb-15"
        >
          {{ formFieldData?.formsFields?.ownedBy?.errors?.ownedbye1 }}
        </div>
      </div>
    </div>
  </form>
</div>
